export const REGIONAL = {
  locale: 'es-CL',
  timeZone: 'America/Santiago',
  currency: 'CLP',
  mapCenter: [-33.4489, -70.6693],
};

const dateParts = (date = new Date()) => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: REGIONAL.timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);

  const y = parts.find((p) => p.type === 'year')?.value;
  const m = parts.find((p) => p.type === 'month')?.value;
  const d = parts.find((p) => p.type === 'day')?.value;
  return { y, m, d };
};

export const toDateInputValueCL = (date = new Date()) => {
  const { y, m, d } = dateParts(date);
  return `${y}-${m}-${d}`;
};

export const daysAgoDateInputCL = (days) => {
  const base = new Date();
  base.setDate(base.getDate() - days);
  return toDateInputValueCL(base);
};
